export default function AutolineNote() {
  return (
    <div className="flex items-center justify-center py-1 italic bg-gray-100 border-b mx-4">
      <span className="text-toyota mr-1 text-xs">Note : </span>
      <span className="text-xs">
        It may take up to 30 mins to synchronize data with Autoline
      </span>
    </div>
  );
}
